import React from 'react';

// App polyfills
import 'canvas-toBlob';

// App Components
import NavigationContainer from './components/NavigationContainer';

// App Config
import AppConfiguration from './services/AppConfiguration';

// Common components
import PageTitle from './components/common/PageTitle/PageTitle';

// Component style
import './app.scss';

// Set app config
AppConfiguration.setConfig(process.env.CONFIG);

export default function AppContainer({ children }) {
  return (
    <div className='wtfApp'>
      <div className='wtfApp_body' id='wtf_body'>
        <div className='wtfApp_bodyContent'>
          <PageTitle />
          <NavigationContainer />
          {children}
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/AppContainer.js